module.exports = __webpack_public_path__ + "static/11-e62a1ae15d81a23f6d3bdcf8bf09d105.jpg";